import * as React from "react";

import "./FieldValidationError.scss";

interface Props {
    show: boolean;
    children: React.ReactNode;
}

export class FieldValidationError extends React.Component<Props> {
    public render() {
        if (this.props.show) {
            return <div className="field-validation-error">
                {this.props.children}
            </div>
        }

        return null;
    }
}